const fontsizes = {
  sm: '8px',
  md: '16px',
  lg: '24px',
};
const fontsizesNum = {
  sm: 8,
  md: 16,
  lg: 24,
};
export { fontsizes, fontsizesNum };
